app.config(function ($translateProvider) {
    $translateProvider.translations('en-gb', {
        IMPORT: 'Import',
        IMPORT_TYPE: 'Type',
        IMPORTS_LIST: 'Imports',
        IMPORT_DETAILS_LIST: 'Details',
        IMPORT_IS_TEST_RUN: 'Test run?',
        IMPORT_STARTED: 'Started at',
        IMPORT_ENDED: 'Ended at',
        IMPORT_TOTAL_ROWS: 'Total',
        IMPORT_VALID_ROWS: 'Valid',
        IMPORT_INVALID_ROWS: 'Invalid',
        IMPORT_FILE_NAME: 'File Name',
        IMPORTED_BY: 'Imported By',
        IMPORT_TEST_RUN: 'Debug',
        IMPORTS: 'Imports',
        IMPORT_CSV_FILE: 'Import file (csv)',
        IMPORT_FILE: 'Import file',
        EXTENSION_XML: '.xml',
        EXTENSION_CSV: '.csv',
        IMPORT_ERRORS: 'Errors',
        IMPORT_ROW_NUMBER: 'Row',
        IMPORT_COLUMN_NAME: 'Key',
        IMPORT_LOGS: 'Import Logs',
        IMPORT_LOG_TYPE: 'Type',
        IMPORT_LOG_ALL: 'All',
        IMPORT_LOG_ERROR: 'Error',
        IMPORT_LOG_CHANGE: 'Change',
        IMPORT_LOG_NO_CHANGE: 'No Change',
        IMPORT_LOG_WARN: 'Warn',
        IMPORT_ERROR_MESSAGE: 'Error message',
        IMPORT_MESSAGE: 'Message',
        IMPORT_GET_TEMPLATE: 'Get Template',
        IMPORTS_NO_RESULTS: 'No results',
        USER_TASK: 'Task (user)',
        USER_ASSET: 'Asset (user)',
        USER_ACTION: 'Action (user)',
        USER_ASSET_TASK: 'Asset/Task (user)',
        TASK_FREQUENCIES: 'Task Frequencies',
        USER_ASSET_TASK_WARNING: 'Please be aware that because you have the Manage Imports permission, the import is not limited to your site access.',
        CONTRACT_WARNING: 'Please be aware that you can only add contracts, not update them.',
        SFG_IMPORT_WARNING: 'The imported SFG version will become the active version and the previous version will become inactive',
        COMMA_SEPARATED: '(comma separated)',
        SUBASSET: 'Sub Asset',
        USER_SUBASSET: 'Sub Asset (user)',
        WASTE_ENTRY: 'Waste Entry',
        LOCATION_UPDATE: 'Location Updater',

        SPREADSHEET_TITLE: 'Spreadsheet Title',
        VIEW_LEGEND: 'View Legend',
        DATA_REQUIREMENTS: 'Data requirements',

        IMPORT_USERS: 'Import Users',
        IMPORT_USERS_ADD: 'Import Users',
        IMPORT_ADD: 'New Import',
        IMPORT_LEGEND: 'Legend',

        ASSET_IMPORT_ADD: 'New Asset Import',
        SUB_ASSET_IMPORT_ADD: 'New Sub Asset Import',
        IMPORT_SUB_ASSETS: 'Import Sub Assets',
        ASSET_USER_LABEL: 'Asset (User)',
        SUB_ASSET_USER_LABEL: 'Sub Asset (User)',

        DOWNLOAD_IMPORT_TEMPLATE: 'Download {{ entity }} import template',
        IMPORT_ERROR: 'Import Error',
        IMPORT_QUEUED: 'Import Queued',
        SITE_TENANT: 'Site Tenant',
        SITE_NOTE: 'Site Notes',

        PCD_IMPORTS: 'PCD Import',
        PCD_LIST: 'PCD Imports List',
        PCD_IMPORT_ADD: 'New PCD Import',
        PCD_IMPORT_CREATE_SITES: 'Create Sites',
        PCD_IMPORT_CREATE_SITE_GROUPS: 'Create Site Groups',
        PCD_IMPORT_CREATE_SECTORS: 'Create Sectors',
        PCD_IMPORT_CREATE_REGIONS: 'Create Regions',
        PCD_IMPORT_CREATE_USERS: 'Create Users',
        PCD_IMPORT_CREATE_CORE_CLIENTS: 'Create Core Clients',
        PCD_IMPORT_UPDATE_SITE_CONTACTS: 'Update Site Contacts',
        PCD_IMPORT_UPDATE_SITE_ACCESS: 'Update Site Access',
        PCD_IMPORT_UPDATE_SITE: 'Update Site',
        PCD_IMPORT_UPDATE_SITE_GROUP: 'Update Site Group',

        NO_PCD_IMPORT_FILE_ADDED: 'No PCD Import File Added',
        DOWNOLAD_ASSET_TYPES : 'Download Asset Types',
        DOWNOLAD_SERVICE_ROUTINES: 'Download Service Routines',
        DOWNOLAD_STATUTORY_TYPES: 'Download Statutory Types',
        DOWNOLAD_DOCUMENT_TYPES: 'Download Document Types',

        CREATE_OPTIONS: 'Create Options',
        UPDATE_OPTIONS: 'Update Options',
        KEY_OPTIONS: 'Key Options',
        PCD: 'PCD',
        PCD_DISABLED_FOR_CLIENT: 'PCD Imports are not enabled',

        SCD_IMPORTS: 'SCD Imports',
        SCD_LIST: 'SCD List',
        SCD_IMPORT_ADD: 'New SCD Import',
        SCD: 'SCD',
        SCD_IMPORT_CREATE_SERVICE_PROVIDER: 'Create Service Provider',
        SCD_IMPORT_CREATE_SERVICE_PROVIDER_GROUP: 'Create Service Provider Group',
        SCD_IMPORT_CREATE_PARTNERSHIP: 'Create Partnership',
        SCD_IMPORT_UPDATE_SERVICE_PROVIDER: 'Update Service Provider',
        SCD_IMPORT_UPDATE_SERVICE_PROVIDER_GROUP: 'Update Service Provider Group',
        SCD_IMPORT_UPDATE_PARTNERSHIP: 'Update Partnership',
        SITE_CONTACT_DOESNT_EXIST: 'Site Contact Doesn\'t Exist',
        PARENT_ALREADY_HAS_A_PARENT: 'Parent meter specified already has a parent - only one level of nesting supported.',
        PARENT_BELONGS_TO_DIFFERENT_SITE: 'The parent meter specified belongs to a different site.',
        CANNOT_CHANGE_PARENT: 'Cannot change parent',
        CANNOT_CHANGE_PARENT_OF_SUB_METER: 'Cannot change parent of submeter.',
        CANNOT_CHANGE_PARENT_OF_SUB_ASSET: 'Cannot change parent of sub asset.',
        PARENT_IS_NOT_ACTIVE: 'The Parent meter is inactive.',

        METER_READING: 'Meter Reading',

        EXPORT_IMPORT_LOGS: 'Export Logs',
        'SFG-CSV': 'Service Routine - CSV',
        SFG: 'SFG-XML',
        IMPORTS_FORM_IDS: 'Form IDs',

        DEBUG: 'Debug',
        DATE_ENDED_AT: 'Ended At',
        ROW: 'Row',

        IMPORTS_CONTRACT_APPROVAL_REQUIRED: 'Contract Approval Required',
        IMPORTS_CONTRACT_APPROVERS_ID: 'Contract Approvers ',
    });
});
